module.exports = __webpack_public_path__ + "media/images/app/thank-you-page/thankyou-hero-88265468c1ccd1fc0bda89cd2161eb71.webp";